import React, { Component } from "react";
import {
  Button,
  Form,
  InputGroup,
  FormControl,
  Row,
  Col,
  Tabs,
  Tab,
  ListGroup,
} from "react-bootstrap";

import { connect } from "react-redux";
import { hidesPricing } from "../../../lib/config/templateTypes";
import ColorPicker from "../../../../com/lib/plugins/color-picker/ColorPicker";
import TableTextStyleFields from "./TableTextStyleFields";
import FieldLabel from "./FieldLabel";
import { updateItems } from "../../../../redux/actions/TemplateActions";
import { getTableMetrics, getTableBorderRadius } from "../../../../com/lib/bands/bandModel";

import {
  changeProprty,
  changeProprtyM,
  companyPath,
  createTableElement,
  resolveTableCellStyle,
  COLUMN_FORMAT_TYPES,
  getColumnFormat,
  isNumericColumnFormat,
  formatColumnValue,
} from "../../../../com/lib/global/helpers";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(faLightbulb);

// Hover help for the column card fields.
const COLUMN_FIELD_TIPS = {
  header: "Text shown in this column's heading row.",
  format: "How values in this column are shown: Text as-is, Number, Currency (with the invoice's currency symbol) or Percentage.",
  width: "Share of the table width for this column. Widths are relative to the other columns.",
  decimals: "Number of decimal places to show. Values are rounded to fit.",
  negativeStyle: "How negative values are shown: with a minus sign or in brackets.",
  currencyPosition: "Show the currency symbol before or after the amount.",
  thousandsSeparator: "Group thousands with commas, e.g. 1,234,567.",
  hideZero: "Leave the cell empty when the value is 0.",
};

// Line-item definitions offered as the table's item list (invoice and
// purchase order). Other List definitions, like the VAT summary, are not.
const ITEM_LIST_DEFINITIONS = ["EposSalesFieldsDefintion", "EposPurchaseOrderFieldsDefintion"];

class Items extends Component {
  constructor(props) {
    super(props);

    this.state = {
      styleTarget: "table",
      // Drag-and-drop reordering of table columns.
      dragColumnKey: null,
      dropTarget: null, // { key, position: "before" | "after" }
      attributes: props.attributes,
      selectedAttributePath: props.selectedAttributePath,
    };
  }

  _selectAttributeSection = (key) => {
    var properties = {
      ...this.props.properties,
      defenition: key,
    };
    //console.log(properties);
    this.props.updateItems(properties);
  };

  _addItem = (e, key) => {
    //console.log("key", companyPath())
    // console.log(e)
    var add = e.target.checked;
    var ele = undefined;
    if (add) ele = createTableElement(companyPath() + "." + key);
    var properties = {
      ...this.props.properties,
      items: {
        ...this.props.properties.items,
        [key]: ele,
      },
    };

    this.props.updateItems(JSON.parse(JSON.stringify(properties)));
  };

  // One available column: added columns are a light card (app navy accent,
  // "Added" tag) with their header text, width and currency; columns not
  // added are a plain row with an "Add" button. Styling is in the Layout tab.
  _renderColumnRow = (key) => {
    const column = this.props.properties.items[key];
    const set = (field, value) =>
      changeProprtyM("items." + key + "." + field, value, this.props, this.props.updateItems);
    const toggle = (checked) => this._addItem({ target: { checked } }, key);
    const format = getColumnFormat(column);

    if (!column) {
      return (
        <ListGroup.Item key={key} className="item-column item-column--available">
          <span className="item-column-name" title={key}>{key}</span>
          <Button
            size="sm"
            variant="outline-primary"
            className="item-column-add"
            onClick={() => toggle(true)}
          >
            <FontAwesomeIcon icon="plus" className="me-1" />
            Add
          </Button>
        </ListGroup.Item>
      );
    }

    const drop = this.state.dropTarget;
    const dropClass = drop && drop.key === key && this.state.dragColumnKey !== key ? " is-drop-" + drop.position : "";
    const dragClass = this.state.dragColumnKey === key ? " is-dragging" : "";

    return (
      <ListGroup.Item
        key={key}
        className={"item-column item-column--added" + dropClass + dragClass}
        data-column-key={key}
        onDragOver={(e) => this._onColumnDragOver(e, key)}
        onDrop={(e) => this._onColumnDrop(e, key)}
      >
        <div className="item-column-header">
          <button
            type="button"
            className="item-column-drag"
            draggable
            title="Drag to reorder (or focus and use ↑ / ↓)"
            aria-label={"Move column " + key}
            onDragStart={(e) => this._onColumnDragStart(e, key)}
            onDragEnd={this._onColumnDragEnd}
            onKeyDown={(e) => this._onColumnHandleKeyDown(e, key)}
          >
            <FontAwesomeIcon icon="grip-vertical" />
          </button>
          <span className="item-column-badge">
            <FontAwesomeIcon icon="check" className="me-1" />
            Added
          </span>
          <span className="item-column-name" title={key}>{key}</span>
          <Button
            size="sm"
            variant="link"
            className="item-column-remove"
            title="Remove this column"
            onClick={() => toggle(false)}
          >
            <FontAwesomeIcon icon="times" />
          </Button>
        </div>

        <div className="item-column-fields">
          <div className="item-column-field item-column-field--full">
            <div className="item-column-header-format">
              <div className="item-column-header-input">
                <FieldLabel id={"header-" + key} text="Header" tip={COLUMN_FIELD_TIPS.header} />
                <FormControl
                  size="sm"
                  value={column.header || ""}
                  onChange={(e) => set("header", e.target.value)}
                />
              </div>
              <div className="item-column-format-select">
                <FieldLabel id={"format-" + key} text="Format" tip={COLUMN_FIELD_TIPS.format} />
                <select
                  className="form-select form-select-sm"
                  value={format.type}
                  onChange={(e) => this._setColumnFormat(key, { type: e.target.value }, true)}
                >
                  {COLUMN_FORMAT_TYPES.filter((t) => !(this.props.hidesPricing && t.value === "currency") || t.value === format.type).map((t) => (
                    <option key={t.value} value={t.value}>{t.label}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="item-column-field">
            <FieldLabel id={"width-" + key} text="Width" tip={COLUMN_FIELD_TIPS.width} />
            <InputGroup size="sm">
              <FormControl
                type="number"
                min="1"
                value={column.width ?? ""}
                onChange={(e) => set("width", e.target.value)}
              />
              <InputGroup.Text>%</InputGroup.Text>
            </InputGroup>
          </div>

          {/* Long values continue on more lines and the row grows; the
              editor passes onWrapChange when the feature is available. */}
          {this.props.onWrapChange && (
            <div className="item-column-field">
              <Form.Check
                type="checkbox"
                id={"wrap-" + key}
                label="Wrap long text"
                checked={!!column.wrap}
                onChange={(e) => this.props.onWrapChange(key, e.target.checked)}
              />
            </div>
          )}

          {isNumericColumnFormat(format) && this._renderFormatOptions(key, format)}
        </div>
      </ListGroup.Item>
    );
  };

  // Changes a column's value format. `showCurrency` is kept in sync for
  // consumers that only know that flag. Switching type resets the options to
  // that type's defaults.
  _setColumnFormat = (key, patch, resetOptions = false) => {
    const column = this.props.properties.items[key];
    const current = getColumnFormat(column);
    const format = resetOptions ? { type: patch.type } : { ...current, ...patch };
    changeProprtyM(
      "items." + key,
      { ...column, format, showCurrency: format.type === "currency" },
      this.props,
      this.props.updateItems
    );
  };

  // Options for number / currency / percentage columns.
  _renderFormatOptions = (key, format) => {
    const setFormat = (patch) => this._setColumnFormat(key, patch);
    const example = formatColumnValue(-1234.5, { format }, "$");

    return (
      <>
        <div className="item-column-field">
          <FieldLabel id={"decimals-" + key} text="Decimals" tip={COLUMN_FIELD_TIPS.decimals} />
          <select
            className="form-select form-select-sm"
            value={format.decimals}
            onChange={(e) => setFormat({ decimals: Number(e.target.value) })}
          >
            {[0, 1, 2, 3, 4].map((d) => (
              <option key={d} value={d}>{d === 0 ? "None" : d}</option>
            ))}
          </select>
        </div>

        <div className="item-column-field">
          <FieldLabel id={"negative-" + key} text="Negative numbers" tip={COLUMN_FIELD_TIPS.negativeStyle} />
          <select
            className="form-select form-select-sm"
            value={format.negativeStyle}
            onChange={(e) => setFormat({ negativeStyle: e.target.value })}
          >
            <option value="minus">-1,234</option>
            <option value="brackets">(1,234)</option>
          </select>
        </div>

        {format.type === "currency" && (
          <div className="item-column-field">
            <FieldLabel id={"symbol-" + key} text="Symbol position" tip={COLUMN_FIELD_TIPS.currencyPosition} />
            <div className="item-column-segmented">
              {[["before", "$100"], ["after", "100 $"]].map(([pos, text]) => (
                <button
                  key={pos}
                  type="button"
                  className={format.currencyPosition === pos ? "active" : ""}
                  onClick={() => setFormat({ currencyPosition: pos })}
                >
                  {text}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="item-column-field item-column-field--full item-column-format-checks">
          <Form.Check
            type="checkbox"
            id={"item-thousands-" + key}
            label={<FieldLabel id={"thousands-" + key} as="span" text="Thousands separator" tip={COLUMN_FIELD_TIPS.thousandsSeparator} />}
            checked={!!format.thousandsSeparator}
            onChange={(e) => setFormat({ thousandsSeparator: e.target.checked })}
          />
          <Form.Check
            type="checkbox"
            id={"item-hidezero-" + key}
            label={<FieldLabel id={"hidezero-" + key} as="span" text="Hide zero values" tip={COLUMN_FIELD_TIPS.hideZero} />}
            checked={!!format.hideZero}
            onChange={(e) => setFormat({ hideZero: e.target.checked })}
          />
        </div>

        <div className="item-column-field item-column-field--full item-column-format-example">
          Example: <strong>{example}</strong>
        </div>
      </>
    );
  };

  // ---- Layout tab: whole-table vs one-column styling ----

  _getStyleTargetColumnKey = () => {
    const target = this.state.styleTarget;
    return target && target !== "table" && this.props.properties.items[target] ? target : null;
  };

  _setTableTextStyle = (part, columnKey, field, value) => {
    if (!columnKey) {
      changeProprtyM(
        "layout." + (part === "header" ? "tableHeader" : "itemRow") + "." + field,
        value,
        this.props,
        this.props.updateItems
      );
      return;
    }
    const styleKey = part === "header" ? "headerStyle" : "rowStyle";
    const column = this.props.properties.items[columnKey];
    this.props.updateItems({
      ...this.props.properties,
      items: {
        ...this.props.properties.items,
        [columnKey]: { ...column, [styleKey]: { ...(column[styleKey] || {}), [field]: value } },
      },
    });
  };

  // Clears one override (or all of a part's overrides when `field` is null).
  _resetTableTextStyle = (part, columnKey, field) => {
    const column = this.props.properties.items[columnKey];
    if (!column) return;
    const styleKeys = part ? [part === "header" ? "headerStyle" : "rowStyle"] : ["headerStyle", "rowStyle"];
    const next = { ...column };
    styleKeys.forEach((styleKey) => {
      if (field) {
        const style = { ...(column[styleKey] || {}) };
        delete style[field];
        next[styleKey] = style;
      } else {
        next[styleKey] = {};
      }
    });
    this.props.updateItems({
      ...this.props.properties,
      items: { ...this.props.properties.items, [columnKey]: next },
    });
  };

  _renderTableTextStyle = (part, columnKey = null) => {
    const column = columnKey ? this.props.properties.items[columnKey] : null;
    const overrides = column ? (part === "header" ? column.headerStyle : column.rowStyle) || {} : null;
    return (
      <TableTextStyleFields
        effective={resolveTableCellStyle(this.props.properties.layout, column, part)}
        overrides={overrides}
        onChange={(field, value) => this._setTableTextStyle(part, columnKey, field, value)}
        onReset={(field) => this._resetTableTextStyle(part, columnKey, field)}
      />
    );
  };

  _renderStyleTargetPicker = () => {
    const items = this.props.properties.items || {};
    const columnKey = this._getStyleTargetColumnKey();
    const addedKeys = Object.keys(items).filter((k) => items[k]);
    return (
      <Form.Group className="items-layout-picker">
        <div className="items-layout-title">Apply to</div>
        <select
          className="form-select form-select-sm"
          value={columnKey || "table"}
          onChange={(e) => this.setState({ styleTarget: e.target.value })}
        >
          <option value="table">Whole table</option>
          {addedKeys.length > 0 && (
            <optgroup label="One column">
              {addedKeys.map((k) => (
                <option key={k} value={k}>{items[k].header || k}</option>
              ))}
            </optgroup>
          )}
        </select>
        <Form.Text className="text-muted items-layout-hint">
          {columnKey
            ? "Changes apply to this column only. Anything not changed follows the whole table."
            : "Applies to every column. Pick a column to change just that one."}
        </Form.Text>
      </Form.Group>
    );
  };

  _setLayout = (path, value) =>
    changeProprtyM("layout." + path, value, this.props, this.props.updateItems);

  _renderLayoutColour = (label, value, onChange) => (
    <div className="table-style-field compact-colour-field">
      <div className="table-style-label"><span>{label}</span></div>
      <ColorPicker color={value} callbackFromParents={(e) => onChange(e.hex)} />
    </div>
  );

  _renderLayoutNumber = (label, value, unit, onChange, extra = {}) => (
    <div className="table-style-field">
      <div className="table-style-label"><span>{label}</span></div>
      <InputGroup size="sm">
        <FormControl type="number" value={value ?? ""} onChange={(e) => onChange(e.target.value)} {...extra} />
        <InputGroup.Text>{unit}</InputGroup.Text>
      </InputGroup>
    </div>
  );

  // Whole-table settings: text styles for headings and rows, plus the
  // table-only border and line options.
  _renderWholeTableLayout = () => {
    const layout = this.props.properties.layout || {};
    const header = layout.tableHeader || {};
    const row = layout.itemRow || {};

    return (
      <>
        <section className="items-layout-section">
          <div className="items-layout-title">Table</div>
          <div className="table-style-fields">
            {this._renderLayoutColour("Border Colour", layout.tableBorder, (hex) => this._setLayout("tableBorder", hex))}
            {this._renderLayoutNumber("Corner Radius", getTableBorderRadius(layout), "px",
              (v) => this._setLayout("tableBorderRadius", v === "" ? 0 : Math.max(0, Number(v) || 0)), { min: 0, step: 1 })}
          </div>
        </section>

        <section className="items-layout-section">
          <div className="items-layout-title">Table Header</div>
          {this._renderTableTextStyle("header")}
          <Form.Check
            type="checkbox"
            id="items-header-bottom-border"
            className="items-layout-check"
            label="Show bottom border"
            checked={!!header.showBottomBorder}
            onChange={(e) => this._setLayout("tableHeader.showBottomBorder", e.target.checked)}
          />
          {header.showBottomBorder && (
            <div className="table-style-fields items-layout-sub">
              {this._renderLayoutColour("Colour", header.bottomBorderColor || "#333333ff",
                (hex) => this._setLayout("tableHeader.bottomBorderColor", hex))}
              {this._renderLayoutNumber("Thickness", header.bottomBorderSize ?? 1, "px",
                (v) => this._setLayout("tableHeader.bottomBorderSize", v), { min: 0 })}
              {this._renderLayoutNumber("Width", header.bottomBorderWidth ?? 100, "%",
                (v) => this._setLayout("tableHeader.bottomBorderWidth", v), { min: 0, max: 100 })}
            </div>
          )}
        </section>

        <section className="items-layout-section">
          <div className="items-layout-title">Item Rows</div>
          {this._renderTableTextStyle("row")}
          {this.props.onRowHeightChange && this._renderRowHeight(layout)}
          <Form.Check
            type="checkbox"
            id="items-row-stripes"
            className="items-layout-check"
            label="Different colour for even rows"
            checked={!!row.stripeRows}
            onChange={(e) => this._setLayout("itemRow.stripeRows", e.target.checked)}
          />
          {row.stripeRows && (
            <>
              <div className="table-style-fields items-layout-sub">
                {this._renderLayoutColour("Even row colour", row.evenRowBackgroundColor || "#F5F5F5FF",
                  (hex) => this._setLayout("itemRow.evenRowBackgroundColor", hex))}
              </div>
              <Form.Text className="text-muted d-block items-layout-sub">
                Background above is used for rows 1, 3, 5…; this colour for rows 2, 4, 6….
              </Form.Text>
            </>
          )}
          <Form.Check
            type="checkbox"
            id="items-row-horizontal-lines"
            className="items-layout-check"
            label="Show horizontal lines"
            checked={!!row.showHorizontalLines}
            onChange={(e) => this._setLayout("itemRow.showHorizontalLines", e.target.checked)}
          />
          {row.showHorizontalLines && (
            <div className="table-style-fields items-layout-sub">
              {this._renderLayoutColour("Colour", row.horizontalLineColor,
                (hex) => this._setLayout("itemRow.horizontalLineColor", hex))}
              {this._renderLayoutNumber("Thickness", row.horizontalLineSize, "px",
                (v) => this._setLayout("itemRow.horizontalLineSize", v), { min: 0 })}
            </div>
          )}
          <Form.Check
            type="checkbox"
            id="items-row-vertical-lines"
            className="items-layout-check"
            label="Show vertical lines"
            checked={!!row.showVerticleLines}
            onChange={(e) => this._setLayout("itemRow.showVerticleLines", e.target.checked)}
          />
          {row.showVerticleLines && (
            <div className="table-style-fields items-layout-sub">
              {this._renderLayoutColour("Colour", row.verticleLineColor,
                (hex) => this._setLayout("itemRow.verticleLineColor", hex))}
              {this._renderLayoutNumber("Thickness", row.verticleLineSize, "px",
                (v) => this._setLayout("itemRow.verticleLineSize", v), { min: 0 })}
            </div>
          )}
        </section>
      </>
    );
  };

  // Height of a one-line item row. Empty is automatic; the table sizes
  // (getTableMetrics) keep at least one line of text plus 2px above and below.
  _renderRowHeight = (layout) => {
    const itemRow = layout.itemRow || {};
    const auto = getTableMetrics({ ...layout, itemRow: { ...itemRow, rowHeight: undefined } }).rowHeight;
    const smallest = getTableMetrics({ ...layout, itemRow: { ...itemRow, rowHeight: 1 } }).rowHeight;
    return (
      <>
        <div className="table-style-fields items-layout-sub">
          {this._renderLayoutNumber("Row height", itemRow.rowHeight ?? "", "px",
            (v) => this.props.onRowHeightChange(v), { min: smallest, step: 1, placeholder: "Auto (" + auto + ")" })}
        </div>
        <Form.Text className="text-muted d-block items-layout-sub">
          Leave empty for automatic ({auto}px). Smallest for this font size: {smallest}px.
        </Form.Text>
      </>
    );
  };

  _renderColumnStyleEditor = (columnKey) => (
    <>
      <section className="items-layout-section">
        <div className="items-layout-title">Header</div>
        {this._renderTableTextStyle("header", columnKey)}
      </section>
      <section className="items-layout-section">
        <div className="items-layout-title">Item Rows</div>
        {this._renderTableTextStyle("row", columnKey)}
      </section>
      <section className="items-layout-section">
        <Button
          size="sm"
          variant="outline-secondary"
          onClick={() => this._resetTableTextStyle(null, columnKey, null)}
        >
          Reset column to table
        </Button>
        <Form.Text className="text-muted d-block mt-2">
          Borders and lines are set for the whole table.
        </Form.Text>
      </section>
    </>
  );

  _getAvailableColumnKeys = () => {
    const definition = this.props.properties.defenition;
    const properties = definition && this.state.attributes[definition]?.Properties;
    if (!properties) return [];
    return [
      ...Object.keys(properties).filter((p) => p !== "CustomArray"),
      ...Object.keys(properties.CustomArray || {}),
    ];
  };

  // ---- Column order (drag and drop) ----
  // The order of `items.items` is the table's column order everywhere: the
  // canvas, the preview, the saved HTML and the PDF backend (which pairs the
  // n-th heading with the n-th column), so reordering rebuilds that object.

  _getTableColumnKeys = () => {
    const items = this.props.properties.items || {};
    return Object.keys(items).filter((k) => items[k]);
  };

  _moveColumn = (fromKey, toKey, position) => {
    if (!fromKey || !toKey || fromKey === toKey) return;
    const items = this.props.properties.items || {};
    const order = this._getTableColumnKeys().filter((k) => k !== fromKey);
    const target = order.indexOf(toKey);
    if (target === -1) return;
    order.splice(position === "after" ? target + 1 : target, 0, fromKey);

    const reordered = {};
    order.forEach((k) => { reordered[k] = items[k]; });
    this.props.updateItems({ ...this.props.properties, items: reordered });
  };

  _onColumnDragStart = (e, key) => {
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", key);
    // Show the whole card while dragging, not just the handle.
    const card = e.currentTarget.closest(".item-column");
    if (card && e.dataTransfer.setDragImage) e.dataTransfer.setDragImage(card, 16, 16);
    this.setState({ dragColumnKey: key, dropTarget: null });
  };

  _onColumnDragOver = (e, key) => {
    if (!this.state.dragColumnKey) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    const rect = e.currentTarget.getBoundingClientRect();
    const position = e.clientY < rect.top + rect.height / 2 ? "before" : "after";
    const current = this.state.dropTarget;
    if (!current || current.key !== key || current.position !== position) {
      this.setState({ dropTarget: { key, position } });
    }
  };

  _onColumnDrop = (e, key) => {
    e.preventDefault();
    const fromKey = this.state.dragColumnKey;
    const position = this.state.dropTarget?.key === key ? this.state.dropTarget.position : "before";
    this.setState({ dragColumnKey: null, dropTarget: null });
    this._moveColumn(fromKey, key, position);
  };

  _onColumnDragEnd = () => this.setState({ dragColumnKey: null, dropTarget: null });

  // Keyboard alternative: ↑ / ↓ on a focused handle moves the column.
  _onColumnHandleKeyDown = (e, key) => {
    if (e.key !== "ArrowUp" && e.key !== "ArrowDown") return;
    e.preventDefault();
    const order = this._getTableColumnKeys();
    const index = order.indexOf(key);
    const neighbour = order[e.key === "ArrowUp" ? index - 1 : index + 1];
    if (!neighbour) return;
    this._moveColumn(key, neighbour, e.key === "ArrowUp" ? "before" : "after");
    // Keep focus on the moved column's handle.
    window.requestAnimationFrame(() => {
      const handle = document.querySelector(`[data-column-key="${key}"] .item-column-drag`);
      if (handle) handle.focus();
    });
  };

  // Columns in the table (in table order, draggable), then the ones that can
  // still be added.
  _renderItems = () => {
    const available = this._getAvailableColumnKeys();
    const inTable = this._getTableColumnKeys();
    const notAdded = available.filter((k) => !this.props.properties.items[k]);

    return (
      <>
        <div className="item-columns-group-title">
          In the table
          {inTable.length > 1 && <span className="text-muted fw-normal"> · drag to reorder</span>}
        </div>
        {inTable.length > 0 ? (
          <ListGroup className="item-columns mb-3">
            {inTable.map((key) => this._renderColumnRow(key))}
          </ListGroup>
        ) : (
          <p className="text-muted small mb-3">No columns yet. Add some from the list below.</p>
        )}

        {notAdded.length > 0 && (
          <>
            <div className="item-columns-group-title">Available</div>
            <ListGroup className="item-columns">
              {notAdded.map((key) => this._renderColumnRow(key))}
            </ListGroup>
          </>
        )}
      </>
    );
  };

  render() {
    return (
      <>
        <div className="column-header">
          <span className="font-large">Items Properties</span>
          <Button
            variant="link ml-2"
            className="text-dark text-decoration-none"
            onClick={(e) => {
              this.props.showToolTips(true);
            }}
          >
            <FontAwesomeIcon icon="lightbulb" className="me-2" />
            Tool Tips
          </Button>
        </div>
        <div className="column-body">
          {/* Section settings (where it prints, height, …), passed in by the editor. */}
          {this.props.sectionSettings}
          {this.props.properties ? (
            <Form>
              <Tabs id="controlled-tab">
                <Tab eventKey="labels" title="Labels">
                  <Row>
                    <Col>
                      <Form.Group className="mt-3">
                        <Form.Label>Item List</Form.Label>

                        <ListGroup>
                          {Object.keys(this.state.attributes).map((key) => {
                            if (
                              ITEM_LIST_DEFINITIONS.includes(key)
                            ) {
                              return (
                                <ListGroup.Item
                                  key={key}
                                  onClick={(e) =>
                                    this._selectAttributeSection(key)
                                  }
                                  className={
                                    "d-flex justify-content-between lh-condensed " +
                                    (this.props.properties.defenition === key
                                      ? "bg-primary text-white"
                                      : "bg-white")
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <div>
                                    <h6 className="my-0 tmplate-multiline-text">{key}</h6>
                                    <small
                                      className={
                                        "small " +
                                        (this.props.properties.defenition ===
                                          key
                                          ? "bg-primary text-white"
                                          : "bg-white")
                                      }
                                    >
                                      {Object.keys(
                                        this.state.attributes[key].Properties
                                      ).length + " inherited properties"}
                                    </small>
                                  </div>
                                </ListGroup.Item>
                              );
                            }
                          })}
                        </ListGroup>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group>
                        <div className="d-flex justify-content-between align-items-baseline">
                          <Form.Label className="fw-bold">Table Columns</Form.Label>
                          {this._getAvailableColumnKeys().length > 0 && (
                            <small className="text-muted">
                              {this._getAvailableColumnKeys().filter((k) => this.props.properties.items[k]).length}
                              {" of "}
                              {this._getAvailableColumnKeys().length} added
                            </small>
                          )}
                        </div>
                        {this._renderItems()}
                      </Form.Group>
                    </Col>
                  </Row>
                </Tab>
                <Tab eventKey="layout" title="Layout">
                  <div className="items-layout">
                    {this._renderStyleTargetPicker()}
                    {this._getStyleTargetColumnKey()
                      ? this._renderColumnStyleEditor(this._getStyleTargetColumnKey())
                      : this._renderWholeTableLayout()}
                  </div>
                </Tab>
              </Tabs>
            </Form>
          ) : (
            <></>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    properties: state.template.items,
    hidesPricing: hidesPricing(state.current.selectedTemplateType),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateItems: (e) => dispatch(updateItems(e)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Items);
